import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {TweenMax, Power3} from 'gsap';

export default class PageContent extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    TweenMax.to(this.content, 0.75, {
      'delay': 0.2,
      'y': 0,
      'opacity': 1,
      'ease': Power3.easeOut
    });
  }

  render() {
    const mainClasses = classNames('page-main js-page-main', {}, this.props.mainClasses);

    return (
      <div className={mainClasses} ref={el => { this.content = el; }}>
        {this.props.children}
      </div>
    )
  }
}

PageContent.propTypes = {
  'mainClasses': PropTypes.string
};



// WEBPACK FOOTER //
// ./src/client/components/page/page-content.jsx